import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'types/types';
import { setOpenedViews } from 'features/applicationState';
import { generateQueryParams, getSidebarItemProp } from 'utils/Utils';
import { findItemByValueRecursively } from 'components/Layout/CommonService';
const useView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openedViews, sidebarItems } = useSelector(
    (state: RootState) => state.applicationState
  );
  const closeOpenView = (view: any) => {
    const updatedOpenedViews = openedViews.filter((x) => x.value != view.value);
    if (updatedOpenedViews.length === 0) {
      const navItem = findItemByValueRecursively(view.value, sidebarItems);
      if (navItem) {
        const appValue = getSidebarItemProp(navItem, 'appValue');
        if (appValue) {
          navigate(`/view/landingPageView?selectedApp=${appValue}`);
        } else {
          navigate(`/view/landingPageView`);
        }
      } else {
        navigate(`/view/landingPageView`);
      }
    } else {
      const activeView = updatedOpenedViews[updatedOpenedViews.length - 1];
      navigate(
        `/${activeView.type.toLowerCase()}/${activeView.value.toLowerCase()}?${generateQueryParams(
          activeView.properties
        )}`
      );
    }
    dispatch(setOpenedViews(updatedOpenedViews));
  };

  const openView = (viewId) => {
    const view = findItemByValueRecursively(
      viewId,
      sidebarItems
    );
    if(view){
      navigate(
        `/${view.type.toLowerCase()}/${view.value.toLowerCase()}?${generateQueryParams(
          view.properties
        )}`
      );
    }
    else{
      navigate(`/view/${viewId.toLowerCase()}`);    
    }
  }
  return { closeOpenView, openView };
};

export default useView;
